import { Dashboard } from "./pages/dashboard"
import LoginCallback from "./pages/loginCallback"
import { LogoutLandingPage } from "./pages/logoutCallback"
import { VehicleDetails } from "./pages/vehicleDetails"
import Manage from "./pages/manage/manage"
import AddVehicleType from './pages/settings/vehicle_types/addVehicleType'
import { InspectionProcess } from './pages/manage/inspections'
import Settings from './pages/settings/settings'
import { AUTHORIZED_USER_IDS } from './utils/userAuthorization'

type Route = {
  url: string
  name: string
  component: React.ComponentType
  public?: boolean
  navbar?: boolean
  navbarUrl?: string
  allowedUserIds?: readonly string[]
}

export const routes: Route[] = [
  {
    url: '/login_success',
    name: 'Login',
    component: LoginCallback
  },
  {
    url: '/logout',
    name: 'Logout',
    component: LogoutLandingPage,
    public: true
  },
  {
    url: '/vehicle/:vin/:workshopSessionId',
    name: 'Vehicle details',
    component: VehicleDetails,
  },
  {
    url: '/',
    name: 'Dashboard',
    component: Dashboard,
    navbar: true,
  },
  {
    url: '/manage/inspections/:process',
    name: 'Inspection process',
    component: InspectionProcess,
  },
  {
    url: '/manage/*',
    name: 'Manage',
    component: Manage,
    navbar: true,
    navbarUrl: '/manage/manage_vehicles',
  },
  {
    url: '/settings/*',
    name: 'Settings',
    component: Settings,
    navbar: true,
    navbarUrl: '/settings/vehicle_types',
    allowedUserIds: AUTHORIZED_USER_IDS,
  },
  {
    url: '/settings/vehicle_types/add',
    name: 'Add vehicle type',
    component: AddVehicleType,
    allowedUserIds: AUTHORIZED_USER_IDS,
  },

]